import React from 'react';
import loadable from '@loadable/component';

const ContactPage = loadable(() => import('../components/Contact/Contact'));

const ContactUs = () => <ContactPage />;

export default ContactUs